export interface EmojiContextualSearchViewState {
    wordBeforeCursor: string;
    /**
     * Array of emoji keys to show in emoji contextual search popup
     * The string is a key to an emoji. The real emoji can
     * be dereferenced through getEmoji util.
     */
    emojis: string[];
    isSuggesting: boolean;
    isShortcut: boolean;
    isPopupShown: boolean;
    selectedEmojiIndex: number;
    showMore: boolean;
}

export const MAX_CONTEXTUAL_EMOJI_LENGTH = 5;

export default EmojiContextualSearchViewState;
